import React from 'react';
import Icons from '../../../../../../../components/Common/Icons/Icons';
import { Button } from '../../../../../../../components/Common/UI/Button';
import { StepProps } from '../../index';

export default function Step2Enrollment({ handleNextStep }: StepProps) {
  return (
    <>
      <div className="flex gap-4 items-center">
        <div>
          <Icons.AccountsFilled />
        </div>
        <div>
          <h2 className="text-lg font-bold">Terms and Conditions</h2>
        </div>
      </div>

      <p className="font-semibold text-lg">
        Guidance Financial is pleased to announce the introduction of eStatements. You will receive your electronic
        statements whenever they are ready and they will contain the same information as your printed statements.
        Inorder to view your electronic statements, you will need a computer with Internet access and a compatible web
        browser such as Internet Explorer or Netscape Navigator, and an e-mail address, which will be used to notify you
        new electronic statement is available.
      </p>

      <p className="font-semibold text-lg">
        All of your information and financial information are confidential and will not be released or sold to any third
        party. You must agree to the terms set forth in this agreement. If you agree, you will no longer receive printed
        statements in the mail.
      </p>

      <div className="flex flex-wrap gap-4 justify-center sm:justify-between items-center">
        <Button className="bg-[#EF9F00] hover:bg-[#EF9F00E6]">I DO NOT AGREE</Button>
        <Button className="bg-[#51CF7C] hover:bg-[#51CF7CE6]" onClick={() => handleNextStep()}>
          I AGREE
        </Button>
      </div>
    </>
  );
}
